<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      arrayFields: ['items']
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title']
            }),
            {
              component: 'h3',
              innerText: 'Elementy'
            },
            new fields.Formset({
              modelPath: [this, 'form', 'items'],
              items: this.form.items.map((item, i) => ({
                headerLabel: get(item.link, ['video_url']),
                fields: [
                  new fields.Switch({
                    label: 'Film z vimeo',
                    modelPath: [this, 'form', 'items', i, 'is_vimeo']
                  }),
                  new fields.Video({
                    label: 'Wideo',
                    modelPath: [this, 'form', 'items', i, 'video'],
                    condition: !this.form.items[i].is_vimeo
                  }),
                  new fields.Input({
                    label: 'Link do Vimeo',
                    modelPath: [this, 'form', 'items', i, 'video_url'],
                    condition: this.form.items[i].is_vimeo
                  })
                ]
              }))
            })
          ]
        }
      ]
    }
  }
}
</script>
